import { useEffect, useState } from 'react';
import { getCategoryLevelsStatus } from '../../roadmap/api/roadmap';

// Module-level so the dashboard card does not refire on every tab switch (it
// remounts each time renderTabContent runs).
const inFlight = new Map();

function load(studentId) {
  if (!inFlight.has(studentId)) {
    inFlight.set(
      studentId,
      getCategoryLevelsStatus(studentId).catch((err) => {
        inFlight.delete(studentId);
        throw err;
      })
    );
  }
  return inFlight.get(studentId);
}

/** Drop the cached response for a student. Exported for test isolation. */
export function invalidateCategoryLevels(studentId) {
  inFlight.delete(studentId);
}

/**
 * Fetch a student's category-levels rollout status (Family/Activities/
 * Countries word levels). `data` stays null until the response lands, which is
 * how the card tells "not loaded yet" apart from "loaded, nothing to show".
 *
 * @param {string|null|undefined} studentId - falsy defers the fetch entirely
 * @returns {{ data: {enabled: boolean, completedToday?: boolean}|null,
 *             enabled: boolean, completedToday: boolean }}
 */
export function useCategoryLevels(studentId) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!studentId) return undefined;
    let cancelled = false;
    load(studentId)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      // A failed fetch leaves the card invisible on purpose — it is a nudge,
      // never the only way to reach these lessons.
      .catch(() => {
        if (!cancelled) setData(null);
      });
    return () => { cancelled = true; };
  }, [studentId]);

  return {
    data,
    enabled: data?.enabled === true,
    completedToday: data?.completedToday === true,
  };
}
